import React from "react";
import { Container, StepContainer, StepCount, StepName } from "./styles";

interface Step {
  status: "complete" | "progress" | "pending";
  name: string;
}

const Step = ({ stepCount, step }: { stepCount: number; step: Step }) => {
  const { status } = step;
  return (
    <StepContainer highlight={status === "progress"}>
      <StepCount highlight={status === "complete" || status === "progress"}>
        {stepCount}
      </StepCount>
      <StepName highlight={status === "progress"}>{step.name}</StepName>
    </StepContainer>
  );
};

const Progress = ({ steps }: { steps: Step[] }) => {
  return (
    <Container>
      {steps.map((step, i) => {
        return <Step stepCount={i + 1} step={step} />;
      })}
    </Container>
  );
};

export default Progress;
